import { useCurrentUser } from "hooks/useCurrentUser";
import { useMemo } from "react";
import { WORKFLOW_CONFIG_AUTHORIZED_EMAILS } from "encamp-shared/src/constants/workflowConfig";

export function useWorkflowConfigAuth() {
  const { user } = useCurrentUser();

  const isAuthorized = useMemo(() => {
    if (!user?.email) {
      return false;
    }

    const userEmail = user.email.toLowerCase().trim();
    return WORKFLOW_CONFIG_AUTHORIZED_EMAILS.some(
      (authorizedEmail) => authorizedEmail.toLowerCase() === userEmail
    );
  }, [user?.email]);

  return { isAuthorized };
}

